<template>
  <div class="zzhregiter">
    <div class="top"></div>
    <p class="title1">创建子账号</p>
    <div class="content">
      <div class="srk">
        <div class="phone">
          <img src="../../assets/images/loginphone.png" alt="" />
          <input v-model="uname" type="text" placeholder="请输入账号" />
        </div>
      </div>
      <div class="srk">
        <div class="phone">
          <img src="../../assets/images/password.png" alt="" />
          <input v-model="pwd" type="password" placeholder="请输入密码" />
        </div>
      </div>
      <div class="btn" @click="add">确定</div>
    </div>
  </div>
</template>

<script>
import apiFun from "../../servers/apiFun";
import comTool from "../../assets/js/until";
export default {
  data() {
    return {
      uname: "",
      pwd: "",
    };
  },
  created() {
    console.log(this.$route.query);
  },
  methods: {
    add() {
      let data = {
        gid: "100682",
        pid: "100",
        mid: "10000",
        p_mid: "1",
        device_id: "00e7efa241dae8842c8286cf69508e9c",
        client: "h5",
        client_id: "00e7efa241dae8842c8286cf69508e9c",
        tm: comTool.getTm(),
        mobile: this.$route.query.phone,
        password: comTool.getMd5(this.pwd),
        uname: this.uname,
      };
      data.sign = comTool.querySort(data);
      apiFun.AddSub(data).then((res) => {
        console.log(res.data);
        if (res.code == 200) {
          console.log(123);
          this.$cookies.set("access_token", res.data.access_token, "7d");
          this.$cookies.set("uname", res.data.uname, "7d");
          this.$cookies.set("uid", res.data.uid, "7d");
          this.$toast.success(res.msg);
          setTimeout(() => {
            this.$router.replace({
              path: "/my",
            });
            
          }, 1000);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less"  scoped>
.top {
  width: 100vw;
  height: 59.7333vw;
  background-image: url("../../assets/images/loginbanner.png");
  background-size: 100vw 59.7333vw;
  background-repeat: no-repeat;
}
.title1 {
  color: #888;
  font-size: 4.5vw;
  margin-top: 8vw;
}
.content {
  background: #f8f8f8;
  margin-top: 6.1333vw;
  .other {
    width: 80vw;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffa624;
    margin-top: 3vw;
    font-size: 3.5vw;
    span {
      margin: 0 3vw;
    }
  }
  .btn {
    width: 80vw;
    height: 11.4667vw;
    background: #ffa624;
    border-radius: 6vw;
    font-size: 4vw;
    color: #fff;
    text-align: center;
    line-height: 11.4667vw;
    margin: 0 auto;
  }
  .srk {
    width: 80.1333vw;
    height: 11.4667vw;
    border-radius: 6vw;
    border: 0.3vw solid #d6d6d6;
    margin: 0 auto;
    margin-bottom: 5vw;
    .phone {
      width: 80.1333vw;
      height: 11.4667vw;
      display: flex;
      align-items: center;
      p {
        width: 20vw;
        text-align: center;
        color: #ffa624;
        font-size: 4vw;
      }
    }
    img {
      width: 3.4667vw;
      height: 4.4vw;
      margin-left: 4.9333vw;
      margin-right: 2.8vw;
    }
    input {
      height: 11.4667vw;
      width: 45vw;
      background: none;
      font-size: 4vw;
      color: #666666;
    }
  }
}
</style>